import { render, staticRenderFns } from "./concretar-compra.vue?vue&type=template&id=058fd403&scoped=true&"
import script from "./concretar-compra.vue?vue&type=script&lang=js&"
export * from "./concretar-compra.vue?vue&type=script&lang=js&"
import style0 from "./concretar-compra.vue?vue&type=style&index=0&id=058fd403&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058fd403",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderMain: require('/builds/marketing/abstracta.academy-website/components/HeaderMain.vue').default,Accordion: require('/builds/marketing/abstracta.academy-website/components/Accordion.vue').default})
